import { useState } from 'react';

import type { SettingsAppStorage } from '../../../domain/settings';
import { useUserQuery } from '../../../features/user/useUserQuery';
import { appStore } from '../../../services/appStore';
import { setSettingsItems } from '../../../services/windowMessaging';

export const useHasRequestedAccess = () => {
  const userQuery = useUserQuery();
  const key = `hasRequestedAccess-${userQuery.data?.userId ?? ''}`;

  const getInitialValue = () => appStore.getSettingsStorageValue(key as keyof SettingsAppStorage) ?? false;

  const [value, setValue] = useState(getInitialValue());

  const setHasRequestedAccess = (newValue: boolean) => {
    setValue(newValue);
    setSettingsItems({ [key]: true });
    appStore.setSettingsStorageValue({ [key]: true });
  };

  return { hasRequestedAccess: value, setHasRequestedAccess };
};
